import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { objectToQueryString } from '@/utils/sfaas_temp';

export default {
	async getCommCodes(codeType, plantCd) {
		try {
			const response = await client.get(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${codeType}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getList({ searchParams, currentPage, pageUnit }) {
		try {
			const queryStr = objectToQueryString({
				strDt: searchParams.strDt.replaceAll('-', ''),
				period: searchParams.period,
				partNo: searchParams.partNo,
				cofCd: searchParams.cofCd,
				tymaCd: searchParams.tymaCd,
				pgsStCd: searchParams.pgsStCd,
				partClCd: searchParams.partClCd,
				userId: searchParams.userId || searchParams.userName,
				currentPage,
				pageUnit
			});
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCkuStts/v1/lists${queryStr}`);
			return response?.data;
		} catch (error) {
			throw error.response?.data;
		}
	},
	async getGraph({ searchParams }) {
		try {
			const queryStr = objectToQueryString({
				strDt: searchParams.strDt.replaceAll('-', ''),
				period: searchParams.period,
				partNo: searchParams.partNo,
				cofCd: searchParams.cofCd,
				tymaCd: searchParams.tymaCd,
				pgsStCd: searchParams.pgsStCd,
				partClCd: searchParams.partClCd,
				userId: searchParams.userId || searchParams.userName
			});
			const response = await client.get(`${BASE_URL}/pqy/pcku/partCkuStts/v1/graphs${queryStr}`);
			return response?.data;
		} catch (error) {
			console.error('error', error);
			throw error.response?.data;
		}
	}
};
